import { createSlice } from "@reduxjs/toolkit";
import JobAPIs from "api/Details/Details";
import JobListingAPIs from "api/Jobs/index";
import { requests } from "api/index";
import URLS from "api/endPoints";
import request from "superagent";



// Slice

const initialstate = {
  JOBDETAILS: '',
  SearchResult: '',
  MainGroup:""
}

const slice = createSlice({
  name: "DETAILS",
  initialState: {
    details: initialstate,
  },
  reducers: {
    getjobdetails: (state, action) => {
        state.details.JOBDETAILS = action.payload;
    },
    getAllSearchResultsReducer: (state, action) => {
      state.details.SearchResult = action.payload
    },
    getMainGroupReducer: (state, action) => {
      state.details.MainGroup = action.payload
    }

  },
});

export default slice.reducer;

// Actions

const { getjobdetails, getAllSearchResultsReducer,getMainGroupReducer } = slice.actions


export const getDetailsAction = (id) => async (dispatch)=>{
  try {
    let response = await JobAPIs.getsinglejob(id);
    await dispatch(getjobdetails(response));
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
}

export const getAllSearchResultsAction = (payload) => async (dispatch) => {
  try {
    
   let res= await requests.post(URLS.magUrl.searchApi, payload)

    await dispatch(getAllSearchResultsReducer(res))
    return await returnCode(res)
  } catch (error) {
    return console.error(error.message);
  }
}

export const mainGroupAction = () => async (dispatch) => {
  try {
    let response = await JobListingAPIs.groups()
    await dispatch(getMainGroupReducer(response))
    return await returnCode(response)
   }
  catch (error) {
    return console.error(error.message)
  }
}

function returnCode(response) {
  if (response.ResponseCode == 100 || 200) {
    return response;
  } else if (response.ResponseCode == 103) {
    return 103;
  } else {
    return 101;
  }
}
